import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "top-0 end-0 fixed-top toast-container p-3" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("button", {
  class: "btn-close me-2 m-auto",
  type: "button",
  "data-bs-dismiss": "toast"
}, null, -1)
const _hoisted_4 = { class: "fixed-top toast-container p-3 top-50 start-50 translate-middle" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/_createVNode("button", {
  class: "btn-close me-2 m-auto",
  type: "button",
  "data-bs-dismiss": "toast"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.toastsTR, (t, i) => {
        return (_openBlock(), _createBlock("div", {
          class: ["toast hide fade", _ctx.obtenerClaseBG(t) + ' ' + _ctx.obtenerClaseText(t)],
          key: t.id,
          ref: 'toast_' + t.id.toString().substring(2)
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", {
              class: "toast-body",
              innerHTML: t.body
            }, null, 8, ["innerHTML"]),
            _hoisted_3
          ])
        ], 2))
      }), 128))
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.toastsMD, (t, i) => {
        return (_openBlock(), _createBlock("div", {
          class: ["toast hide fade", _ctx.obtenerClaseBG(t) + ' ' + _ctx.obtenerClaseText(t)],
          key: t.id,
          ref: 'toast_' + t.id.toString().substring(2)
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", {
              class: "toast-body",
              innerHTML: t.body
            }, null, 8, ["innerHTML"]),
            _hoisted_6
          ])
        ], 2))
      }), 128))
    ])
  ]))
}